import { BaseDevice, jingtaiV2LightAndSpeedRange } from '../../base_device'
import list_icon from '@/assets/img/device/mg68/list_icon_pro_max.png'
import { DevicePid, EffectIndex, KK, VK } from '@/define/define'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_JTV2 } from '../../light/light_effect_list'
import { mu68VKCodes } from '../keycode/vkeycode'
import { getDeviceKeySquare, square } from '../keysquare/keysquare'

export class Mg68Plus extends BaseDevice {
  magneticAxis: boolean = true
  speedAllowValues: number[] = jingtaiV2LightAndSpeedRange()
  lightAllowValues: number[] = jingtaiV2LightAndSpeedRange()

  minDelayTimer: number = 1
  maxDelayTimer: number = 32768
  name: string = 'MG68_Plus'
  icon: string = list_icon
  width: number = 710

  square = getDeviceKeySquare(DevicePid.CarotmasMars68)
  vkcodes = mu68VKCodes
  inoperableKeys: KK[] = [0x50a]
  fnFactoryKeys: KK[] = [0x100, 0x101, 0x102, 0x103, 0x104, 0x105, 0x106, 0x107, 0x108, 0x109, 0x10a, 0x10b, 0x10c, 0x10d, 0x20b, 0x20c, 0x302, 0x403, 0x501, 0x509, 0x50c, 0x50d, 0x50e, 0x40d]
  customLayout: { [index: number]: square } = {
    0x10d: this.createSquare(2, 2, 82),
    0x200: this.createSquare(2, 2, 54),
    0x20d: this.createSquare(2, 2, 65),
    0x300: this.createSquare(2, 2, 70),
    0x30d: this.createSquare(2, 2, 87),
    0x0400: this.createSquare(2, 2, 74),
    0x040c: this.createSquare(2, 2, 48),
    0x040b: this.createSquare(2, 2, 72),
    0x500: this.createSquare(2, 2, 52),
    0x501: this.createSquare(2, 2, 52),
    0x502: this.createSquare(2, 2, 52),
    0x506: this.createSquare(2, 2, 228),
  }

  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_JTV2

  rate: number[] = [0.25, 0.5, 1, 2, 4, 8]
  sleepTimeValues = [60, 2 * 60, 3 * 60, 5 * 60, 15 * 60, 30 * 60, 1 * 60 * 60, 2 * 60 * 60, 0]
}
